export const SIMPLE_SEARCH_PARAM = 'text';
export const SORT_BY_PARAM = 'sortBy';
export const DIRECTION_PARAM = 'direction';
